<template>
  <NuxtLayout>
    <div class="error">
      <div class="error-info">
        <h1 class="error-info__title">
          404
        </h1>
        <p class="error-info__text">
          {{ $t("error.pageNotFound") }}
        </p>
        <button
          class="error-info__link"
          @mouseover="isHovered = true"
          @mouseleave="isHovered = false"
          @click="handleClearError"
        >
          {{ $t("error.goToHome") }}
          <IconsButtonArrowRightIcon :color="isHovered ? '#cd0008' : '#ed1c24'"/>
        </button>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
defineProps(["error"]);
const isHovered = ref(false);
const handleClearError = () => clearError({ redirect: "/" });
</script>

<style lang="scss" scoped>
.error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 558px;
  padding-top: 68px;

  @media (min-width: $screen-m) {
    height: 630px;
    padding-top: 106px;
  }

  @media (min-width: $screen-l) {
    height: 695px;
    padding-top: 121px;
  }

  @media (min-width: $screen-xl) {
    height: 789px;
  }
}

.error-info {
  text-align: center;
}

.error-info__title {
  font-weight: 600;
  font-size: 64px;
  line-height: 116%;
  color: #ed1c24;

  @media (min-width: $screen-m) {
    font-size: 96px;
    line-height: 114%;
  }

  @media (min-width: $screen-xl) {
    font-size: 120px;
  }
}

.error-info__text {
  font-weight: 500;
  font-size: 16px;
  line-height: 152%;
  color: #282828;
  margin: 16px 0 24px;

  @media (min-width: $screen-m) {
    font-size: 18px;
    line-height: 140%;
    margin: 16px 0 30px;
  }

  @media (min-width: $screen-l) {
    font-size: 20px;
    line-height: 132%;
    margin: 16px 0 40px;
  }

  @media (min-width: $screen-xl) {
    font-size: 24px;
  }
}

.error-info__link {
  display: inline-flex;
  gap: 12px;
  align-items: center;
  height: 56px;
  font-weight: 500;
  font-size: 14px;
  line-height: 146%;
  color: #ed1c24;
  background: #f5f5f5;
  padding: 16px 24px;
  border-radius: 60px;
  transition: 0.2s ease-in;

  &:focus {
    color: #be161d;
  }

  &:hover {
    color: #cd0008;
  }

  @media (min-width: $screen-m) {
    font-size: 16px;
    line-height: 152%;
  }

  @media (min-width: $screen-l) {
    height: 64px;
    font-size: 18px;
    line-height: 156%;
    padding: 18px 20px;
  }
}
</style>
